<script>

export default {
    props: {
        label: {type: String, required: true},
        filterValues: {type: Array, required: true},
        activeFilterValues: {type: Array, required: true, default: function(){return []}},
    },

    data() {
        return {
            showDropdown: false,
        }
    },

    methods: {
        displayValue(val) {
            return val.name || val
        },
        key(val) {
            return val.id || val
        },
        isActive(val) {
            // includes does not work because of query param string types
            for (let v of this.activeFilterValues)
                if (v == this.key(val)) return true
            return false
        }
    }
}
</script>

<template>
    <li class="nav-item dropdown">
        <div class="btn btn-secondary btn-block btn-sm-lg navbar-btn dropdown-toggle me-1 mb-1"
         @click.prevent="showDropdown=!showDropdown">
            {{ label }}
        </div>
        <div v-if="showDropdown" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <template v-for="val in filterValues">
                <label class="dropdown-item">
                <input type="checkbox"
                    @change="$emit('toggle-filter', val)"
                    :checked="isActive(val)"
                />&nbsp; {{displayValue(val)}}
                </label>
            </template>
        </div>
    </li>
</template>

<style scoped>

.c-talk-navbar .nav-link, .c-talk-navbar .dropdown-item { 
    text-decoration: none
}

@media screen and (min-width: 960px) {
    .btn-block {
        display: inline-block;
        width: auto;
    }

    .btn-sm-lg {
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
        line-height: 1.5;
        border-radius: 0rem;
    }
}
</style>